import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { toastr } from 'react-redux-toastr';
import { PUT } from '../../../config/permissions';
import { TOTALPOS_PAYMENT } from '../../../config/endpoints';
import withEndpointAuthorization from '../../units/authorization/withEndPointAuthorization';
import {
  formatPinpadBlackBox,
  formatPinpadEventLine,
  getPinpadSaleEvents,
  subscribePinpadEvents,
} from '../../../utils/pinpadBlackBox';

const copyWithTextarea = (text) => {
  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'fixed';
  textarea.style.opacity = '0';
  document.body.appendChild(textarea);
  textarea.select();
  const copied = document.execCommand('copy');
  document.body.removeChild(textarea);
  return copied;
};

const copyToClipboard = async (text) => {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (error) {
      return copyWithTextarea(text);
    }
  }
  return copyWithTextarea(text);
};

const PinpadActivityLog = ({ userId, saleId }) => {
  const [events, setEvents] = useState(getPinpadSaleEvents(saleId));
  const [expanded, setExpanded] = useState(false);
  const logBoxRef = useRef(null);

  useEffect(() => {
    const refresh = () => setEvents(getPinpadSaleEvents(saleId));
    const unsubscribe = subscribePinpadEvents(refresh);
    refresh();
    return unsubscribe;
  }, [saleId]);

  useEffect(() => {
    if (expanded && logBoxRef.current) {
      logBoxRef.current.scrollTop = logBoxRef.current.scrollHeight;
    }
  }, [expanded, events]);

  const onCopy = async () => {
    try {
      const copied = await copyToClipboard(
        formatPinpadBlackBox({ userId, currentSaleId: saleId }),
      );
      if (copied) {
        toastr.success('Copiado', 'Historial POS copiado al portapapeles');
      } else {
        toastr.error('Error', 'No se pudo copiar el historial POS');
      }
    } catch (error) {
      toastr.error('Error', 'No se pudo copiar el historial POS');
    }
  };

  return (
    <div className="mb-2">
      <Button
        type="button"
        color="link"
        size="sm"
        className="p-0"
        onClick={() => setExpanded(!expanded)}
      >
        <i className={`fa fa-caret-${expanded ? 'down' : 'right'}`} /> Historial
        POS ({events.length})
      </Button>{' '}
      <Button
        type="button"
        color="link"
        size="sm"
        className="p-0"
        onClick={onCopy}
        disabled={!events.length}
      >
        <i className="fa fa-clipboard" /> Copiar
      </Button>
      {expanded && (
        <pre
          ref={logBoxRef}
          className="border rounded bg-light p-2 mt-1 mb-0"
          style={{
            maxHeight: 200,
            overflow: 'auto',
            fontSize: 11,
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-all',
          }}
        >
          {events.length
            ? events.map(formatPinpadEventLine).join('\n')
            : 'Sin eventos registrados'}
        </pre>
      )}
    </div>
  );
};

PinpadActivityLog.propTypes = {
  userId: PropTypes.string,
  saleId: PropTypes.string,
};

PinpadActivityLog.defaultProps = {
  userId: null,
  saleId: null,
};

export default withEndpointAuthorization({
  url: TOTALPOS_PAYMENT,
  permissionType: PUT,
})(PinpadActivityLog);
